import { getLocaleNumberSymbol, NumberSymbol } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, Optional, Self, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FormControlBase } from '../../common/form-control-base/form-control-base';
import { MathHelper } from '../../helpers/math-helper';
import { DigitsInfo } from '../../models/digits-info';
import { ConfigurationManager } from '../../services/configuration-manager.service';
import { MaskitoOptions } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';

@Component({
    selector: 'waf-percent-input',
    templateUrl: './percent-input.component.html',
    styleUrls: ['./percent-input.component.scss'],
    inputs: ['label', 'disabled', 'hideValidationMessages', 'isReadonlyValue', 'placeholder', 'tabindex'],
    standalone: false
})
export class PercentInputComponent extends FormControlBase<number> {

  @Input() allowNegative: boolean;

  @Input() max: number;

  sign: string;

  internalValue: string;

  maskitoOptions: MaskitoOptions;

  private decimalSymbol: string;
  private thousandSeparator: string;
  private digitsInfo: DigitsInfo;

  constructor(
    @Self() @Optional() protected override ngModel: NgControl,
    @Inject(LOCALE_ID) private locale: string,
    private configurationManager: ConfigurationManager) {
    super('waf-percent-input', ngModel);

    this.digitsInfo = this.configurationManager.getPercentDigitInfo();

    this.sign = getLocaleNumberSymbol(locale, NumberSymbol.PercentSign);
  }

  override onInit() {
    this.setupMask();
  }

  override ngOnChanges(changes: SimpleChanges) {
    if (changes.allowNegative) {
      this.setupMask();
    }
  }

  override onValueWritten() {

    if (this.value != null && (this.value as any) !== '') {
      const numberValue = MathHelper.roundToDecimalPlaces(this.value * 100, this.digitsInfo.maxFractionDigits);

      this.internalValue = numberValue.toString().replace('.', this.decimalSymbol);
    }
    else {
      this.internalValue = null;
    }
  }

  onInternalValueChanged(value: string) {
    this.internalValue = value;

    if (value) {
      const regex = new RegExp(`[^-0-9${this.decimalSymbol}]`, 'g');

      let typedValue = value.replace(regex, "").replace(this.decimalSymbol, '.');

                  this.value = MathHelper.roundToDecimalPlaces(parseFloat(typedValue) / 100, this.digitsInfo.maxFractionDigits + 2);
    } else {
      this.value = null;
    }
  }

  private setupMask() {
    const groupSymbol = getLocaleNumberSymbol(this.locale, NumberSymbol.CurrencyGroup);
    this.decimalSymbol = getLocaleNumberSymbol(this.locale, NumberSymbol.CurrencyDecimal);
    this.thousandSeparator = groupSymbol || ',';

    this.maskitoOptions = maskitoNumberOptionsGenerator({
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      thousandSeparator: this.thousandSeparator,
      decimalSeparator: this.decimalSymbol,
      min: this.allowNegative ? -999999 : 0,
      max: 999999
    });
  }


}
